document.addEventListener("DOMContentLoaded", (event) => {
    const isMobile = window.innerWidth < 768;

    LottieScrollTrigger({
        target: ".__lottiedesktop_wrapper",
        // path: "wp-content/themes/theme_altimax/dist/img/lottie_desktop.json",
        path: isMobile ? "wp-content/themes/theme_altimax/dist/img/lottie_mobile.json" : "wp-content/themes/theme_altimax/dist/img/lottie_desktop.json",
        speed: "medium",
        scrub: 2, // seconds it takes for the playhead to "catch up"
        // start: "top top",
        // end: isMobile ? "+=250" : "+=1000", // Ajuster la durée de l'animation pour mobile
        // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
        // you can pass in a "timeline" that has existing animations in it, and LottieScrollTrigger will play that alongside the Lottie animation
        // you can pass a startFrameOffset and/or endFrameOffset to cause the playhead to start/end at a different frame.
    });

    document.querySelector('.__toggle_btn_listpoint').addEventListener('click', () => {
        document.querySelector('.__listpoint').classList.toggle('open');
    });

    function LottieScrollTrigger(vars) {
        let playhead = { frame: vars.startFrameOffset || 0 },
            target = gsap.utils.toArray(vars.target)[0],
            speeds = { slow: "+=2000", medium: "+=1000", fast: "+=500" },
            st = {
                trigger: target,
                pin: true,
                start: "top top",
                end: speeds[vars.speed] || "+=1000",
                scrub: 1
            },
            ctx = gsap.context && gsap.context(),
            animation = lottie.loadAnimation({
                container: target,
                renderer: vars.renderer || "svg",
                loop: false,
                autoplay: false,
                path: vars.path,
                rendererSettings: vars.rendererSettings || {
                    preserveAspectRatio: "xMidYMid slice"
                }
            }),
            frameAnimation;
        for (let p in vars) {
            // let users override the ScrollTrigger defaults
            st[p] = vars[p];
        }
        frameAnimation = vars.timeline || gsap.timeline({ scrollTrigger: st });
        if (vars.timeline && !vars.timeline.vars.scrollTrigger) {
            // if the user passed in a timeline that didn't have a ScrollTrigger attached, create one.
            st.animation = frameAnimation;
            ScrollTrigger.create(st);
        }
        animation.addEventListener("DOMLoaded", function () {
            let createTween = function () {
                animation.goToAndStop(playhead.frame, true);
                frameAnimation.to(playhead, {
                    frame: animation.totalFrames - 1 - (vars.endFrameOffset || 0),
                    ease: "none",
                    duration: frameAnimation.duration() || 1,
                    onUpdate: () => {
                        animation.goToAndStop(playhead.frame, true);
                    }
                }, 0);
                return () => animation.destroy && animation.destroy();
            };
            ctx && ctx.add ? ctx.add(createTween) : createTween();
            // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
            ScrollTrigger.sort();
            ScrollTrigger.refresh();
        });
        animation.frameAnimation = frameAnimation;
        return animation;
    }

   /* let playerdesktop = document.getElementById("__lottiedesktop");
    let playermobile = document.getElementById("__lottiemobile");

    playerdesktop.addEventListener("ready", () => {
        LottieInteractivity.create({
            mode:"scroll",
            player: "#__lottiedesktop",
            container: ".__lottiedesktop_wrapper",
            actions: [
                {
                    visibility:[0.3, 0.55],
                    type: "seek",
                    frames: [0, 49],
                },
            ]
        });
    });

    playermobile.addEventListener("ready", () => {
        LottieInteractivity.create({
            mode:"scroll",
            player: "#__lottiemobile",
            container: ".__lottiemobile_wrapper",
            actions: [
                {
                    visibility:[0.3, 0.55],
                    type: "seek",
                    frames: [0, 49],
                },
            ]
        });
    });

    document.querySelector('.__toggle_btn_listpoint').addEventListener('click', () => {
        document.querySelector('.__listpoint').classList.toggle('open');
    });*/



});